import { Link } from "react-router-dom";

const CATEGORIES = [
  { name: "SUV", icon: "ri-roadster-line", note: "For the rough roads" },
  { name: "Sedan", icon: "ri-taxi-line", note: "Smooth city rides" },
  { name: "Van", icon: "ri-bus-2-line", note: "Group & safari trips" },
  { name: "Hatchback", icon: "ri-car-line", note: "Easy on fuel" },
  { name: "Wagon", icon: "ri-caravan-line", note: "Space for luggage" },
];

export default function CategoryStrip() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {CATEGORIES.map((category) => (
        <Link
          key={category.name}
          to={`/browse?category=${encodeURIComponent(category.name)}`}
          className="group flex flex-col gap-3 rounded-xl surface-card p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/60"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/12 text-2xl text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={category.icon}></i>
          </span>
          <span>
            <span className="block font-heading text-base font-semibold text-foreground-950">{category.name}</span>
            <span className="mt-0.5 block text-xs text-foreground-500">{category.note}</span>
          </span>
        </Link>
      ))}
    </div>
  );
}